import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=17da7c3a&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"
import style0 from "./Discount.vue?vue&type=style&index=0&id=17da7c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17da7c3a",
  null
  
)

export default component.exports